export default __webpack_public_path__ + "static/media/PPI-driveway-014.80bbbe7a.jpg";